<ng-template #chipListComponent>
  <ng-container *ngIf="allowClear && !disabled">
    <div class="flex flex-column">
      <ng-container [ngTemplateOutlet]="chipFormField"></ng-container>
      <a class="link" *ngIf="allowClear && displayInput" (click)="$event.stopPropagation(); removeAll()">
        <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
        <span>{{ 'general.api_chips_clear' | translate }}</span>
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="!allowClear || disabled" [ngTemplateOutlet]="chipFormField"></ng-container>
</ng-template>
<ng-template #chipFormField>
  <mat-form-field appearance="outline" class="{{customClass}}" [floatLabel]="chipListFloatLabelValue"
                  [ngClass]="{'hide': !displayInput, 'field-error': !valid || invalidLength || valueExists || invalidFormat, 'no-hint': hideHint, 'responsive-hint': !hideHint}">
    <mat-label *ngIf="label">{{ label | translate }}</mat-label>
    <mat-chip-grid #chipGrid [disabled]="disabled">
      <mat-chip-row *ngFor="let chip of items" (removed)="removeChip(chip)" [ngClass]="{'invalid': !isItemValid(chip)}" [disabled]="disabled">
        {{ chip }}
        <button matChipRemove [disabled]="disabled">
          <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
        </button>
      </mat-chip-row>
      <input [placeholder]="disabled ? '' : (placeHolder | translate)"
             [matChipInputFor]="chipGrid"
             [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
             [matChipInputAddOnBlur]="true"
             [disabled]="disabled || (maxAmount && items?.length >= maxAmount)"
             (keyup)="checkRegex($event); touched.emit()"
             (matChipInputTokenEnd)="addChip($event)" autocomplete="off">
    </mat-chip-grid>
    <mat-hint class="text-muted" [ngClass]="{'flex space-between max-width': maxAmount}"
              *ngIf="!disabled && (!valid || (valid && (invalidLength || valueExists || invalidFormat)) || (valid && !invalidLength && !valueExists && !invalidFormat && !noHint))">
      <span class="text-warning" *ngIf="!valid">
        <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
        {{ errorMessage | translate }}
      </span>
      <ng-container *ngIf="valid">
        <span class="text-warning" *ngIf="invalidLength || valueExists || invalidFormat">
          <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
          <ng-container *ngIf="invalidLength"> {{ 'general.api_chips_invalid_length' | translate: {minLength: minLength, maxLength: maxLength} }}</ng-container>
          <ng-container *ngIf="valueExists"> {{ invalidLength ? ',' : '' }} {{ 'general.api_chips_invalid_value_exists' | translate }}</ng-container>
          <ng-container *ngIf="invalidFormat"> {{ (invalidLength || valueExists) ? ',' : '' }} {{ 'general.api_chips_invalid_format' | translate }}</ng-container>
        </span>
        <span *ngIf="!invalidLength && !valueExists && !invalidFormat && !noHint">
          <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
          {{ 'general.api_chips_press_enter_to_add' | translate }}
        </span>
      </ng-container>
      <span *ngIf="maxAmount">{{ (items?.length || 0) }}/{{ maxAmount }}</span>
    </mat-hint>
  </mat-form-field>
</ng-template>
